import * as Comlink from 'comlink';
import { BankStatementWorker } from './bankStatementWorker';
import WorkerInstance from './bankStatementWorker?worker&inline';
const worker = new WorkerInstance();
const BankStatementWorkerWrapper = Comlink.wrap<typeof BankStatementWorker>(worker);

export default BankStatementWorkerWrapper;
